define(function (require) {
    'use strict';

    var EventEmitter = require('system/helper/EventEmitter'),
            EventAggregator = require('system/helper/EventAggregator'),
            logger = require('system.logger'),
            cookie = require('cookie');

    require('jquery');
    require('module.system.extension.validator');

    var app = {
        config: {
            loaderClass: 'loader', // class which is used by app.component or $.loadContent for adding progress during loading a content from server
            loaderFunction: []
        },
        loader: {
            display: function ($container) {
                if (app.config.loaderFunction.length > 0) {
                    app.config.loaderFunction[0]($container);
                } else {
                    $container.addClass(app.config.loaderClass);
                }
            },
            hide: function ($container) {
                /*if (app.config.loaderFunction.length > 0) {
                 app.config.loaderFunction[1]($container);
                 }
                 else {
                 $container.removeClass(app.config.loaderClass);
                 }*/
            }
        }
    },
            logger = logger.get('system.app');

    // module
    (function () {

        function getModuleName(name) {
            if (name.indexOf('/') !== -1) {
                name = name.replace(/\//g);
            }

            if (name.toLowerCase() === 'default') {
                name = 'Application';
            }

            return name;
        }

        function bindMethods(obj, configPath) {

            var methods = {
                _cache: {
                    module: {},
                    config: {}
                },
                module: function (name) {
                    name = getModuleName(name);

                    if (typeof this._cache.module[name] === 'undefined') {
                        return this._cache.module[name] = new Module(name, configPath.module[name]);
                    } else {
                        return this._cache.module[name];
                    }
                },
                config: function (name) {
                    name = name || 'general';

                    if (typeof this._cache.config[name] === 'undefined') {
                        this._cache.config[name] = new Config(configPath);
                    }

                    this._cache.config[name]._type = name;

                    return this._cache.config[name];
                }
            };

            for (var method in methods) {
                obj[method] = methods[method];
            }
        }

        var Config = function (path) {

            if (typeof path === 'undefined') {
                logger.warn('Cannot create config class: path not exists %s', path);
            }

            this._path = path || {};
            this._type = null;
        };

        Config.prototype = {
            get: function (item) {
                var args = Array.prototype.slice.call(arguments),
                        data = this._path[this._type] || false;

                if (!data) {
                    return false;
                }

                for (var i in args) {

                    if (typeof data[args[i]] === 'undefined') {
                        logger.warn('Cannot find config item %s', args.join(', '));
                        return false;
                    }

                    data = data[args[i]];
                }

                return data;
            }
        };

        var Lang = function (path) {

            if (typeof path === 'undefined') {
                throw new Error('Cannot create lang class: path not exists');
            }

            this._path = path;
        };

        Lang.prototype = {
            _get: function (type) {
                if (typeof this._path[type] === 'undefined') {
                    logger.warn('Language type %s not defined', type);
                    return {};
                }

                return this._path[type];
            },
            message: function (message) {
                var data = this._get('message');

                if (typeof data[message] === 'undefined') {
                    logger.warn('Language message %s not found', message);
                    return {
                        text: message,
                        type: 'info'
                    };
                }

                return data[message];
            },
            text: function (text) {
                var data = this._get('text');

                if (typeof data[text] === 'undefined') {
                    logger.warn('Language text %s not found', text);
                    return text;
                }

                return data[text];
            },
            component: function (name) {
                var data = this._get('component');

                if (typeof data[name] === 'undefined') {
                    logger.warn('Language component %s not found', name);
                    return false;
                }

                return data[name];
            }
        };

        function Module(name, path) {
            this._name = name;
            this._path = path;

            this._lang = null;

            try {
                this._config = new Config(path.config || {});
            } catch (e) {
                throw new Error('Cannot create module config ' + name + ': ' + e.message);
            }
        }

        Module.prototype = {
            config: function (name) {
                name = name || 'config';

                this._config._type = name;

                return this._config;
            },
            lang: function () {
                if (this._lang === null) {
                    try {
                        this._lang = new Lang(this._path.lang);
                    } catch (e) {
                        throw new Error('Cannot create module lang config ' + this._name + ': ' + e.message);
                    }
                }

                return this._lang;
            }
        };

        app.ENVIRONMENT = _config.ENVIRONMENT;
        app.VERSION = _config.VERSION;
        app.user = {};

        bindMethods(app, _config.app);
        bindMethods(app.user, _config.user);

    })();

    app.extend = function () {
        // _extend does the actual job with two arguments.
        var _extend = function (dst, src) {

            for (var p in src) {
                if (typeof src[p] === 'object' && src[p] instanceof jQuery) {
                    dst[p] = src[p];
                    continue;
                }

                if (!src.hasOwnProperty(p)) {
                    continue;
                }
                if (src[p] === undefined) {
                    continue;
                }
                if (typeof src[p] !== 'object' || src[p] === null) {
                    dst[p] = src[p];
                } else if (typeof dst[p] !== 'object' || dst[p] === null) {
                    dst[p] = _extend(src[p].constructor === Array ? [] : {}, src[p]);
                } else {
                    _extend(dst[p], src[p]);
                }
            }
            return dst;
        }

        // Loop through arguments and merge them into the first argument. 
        var out = arguments[0];
        if (typeof out !== 'object' || out === null)
            return out;
        for (var i = 1, il = arguments.length; i < il; i++) {
            _extend(out, arguments[i]);
        }
        return out;
    };

    app.security = {
        csrf: {
            getToken: function () {
                return cookie.get(app.config().get('security', 'csrf_cookie_tokenName'));
            },
            getName: function () {
                return app.config().get('security', 'csrf_tokenName');
            },
            getCookieName: function () {
                return app.config().get('security', 'csrf_cookie_tokenName');
            },
            insertToObj: function (obj) {
                obj[this.getName()] = this.getToken();

                return obj;
            }
        },
        auth: {
            getParams: function () {
                return {
                    'authData': app.config().get('security', 'authData'),
                    'userID': app.user.config().get('ID'),
                    'csrf_name': app.security.csrf.getName(),
                    'csrf_cookie_name': app.security.csrf.getCookieName(),
                    'csrf_token': app.security.csrf.getToken()
                };
            }
        }
    };

    // system commands callable from ajax request
    app.command = {};

    // default redirect command definition
    app.command.redirect = function (url) {
        window.location = url;
    };

    app.message = {
        template: '<div class="alert main-alert alert-%type% fade in" role="alert">\n\
                        <button type="button" class="close" data-dismis="alert">\n\
                            <span aria-hidden="true">&times;</span>\n\
                            <span class="sr-only">Zavrieť</span>\n\
                        </button>\n\
                        <i class="fa fa-check"></i>\n\
                        %message%\n\
                    </div>',
        interval: 3000,
        _displayMessage: function (message, type) {
            var template = this.template.replace('%type%', type).replace('%message%', message);
            var alert = $(template).appendTo($('body'))./*fadeIn(2000).*/alert();

            setTimeout(function () {
                alert.alert('close');
            }, this.interval);
        },
        error: function (message) {
            this._displayMessage(message, 'danger');
        },
        success: function (message) {
            this._displayMessage(message, 'success');
        },
        warning: function (message) {
            this._displayMessage(message, 'warning');
        },
        info: function (message) {
            this._displayMessage(message, 'info');
        },
        confirm: function (message, callback) {
            if (confirm(message)) {
                callback(true);
                return;
            }

            callback(false);
        }
    };

    /**
     * Methods for loading content in SPA applications
     * 
     * @type {object}
     */
    app.page = app.extend({}, EventEmitter.prototype, {
        init: function (config, callback) {
            var self = this;
            self.config = app.extend(self.config, config);

            self.container = self.config.container;

            // load default or last location
            var defaultLocation = cookie.get('defaultLocation') || app.config().get('route', 'defaultLocation');

            // if hash tag is not empty load it primary
            if (window.location.hash !== '') {
                defaultLocation = window.location.hash.replace('#', '');
            }

            if (defaultLocation) {
                this.display(defaultLocation);
            }

            window.page = {
                route: function (address, params) {
                    self.display(address, params || null);
                },
                replace: function (address, params) {
                    self.replace(address, params || null);
                },
                moveBack: function () {
                    self.moveBack();
                }
            };

            if (callback) {
                callback(self);
            }
        },
        config: {
            container: '#main', // ID of the element where content is changed
            btnMoveBack: '#btn-move-back'
        },
        container: null, // current container
        _btnMoveBack: null,
        _lastPage: null, // url of the last page which was loaded
        _replacedContentList: [],
        _currentPage: null, // current page data
        _hiddenParts: [], // hidden parts 
        _additionalData: null,
        _events: {}, // used by EventEmitter
        _bindingObj: {}, // used by EventEmitter
        /**
         * Change ID of the current container
         * 
         * @param {string} container ID of the element
         * @returns {object} this
         */
        use: function (container) {
            this.container = container;

            return this;
        },
        /**
         * Remove current page data
         * 
         * @returns {object} this
         */
        cleanData: function () {
            this._currentPage.data = {};
            return this;
        },
        /**
         * Display page in container
         * 
         * @param {string} url
         * @param {object} data post or get data
         * @param {function} callback
         * @returns {Boolean}
         */
        display: function (url, data, callback) {
            var self = this;

            this.container = this.container || $(this.config.container);
            data = data || {};

            if (this.container.attr('data-url') !== url) {

                this.container.children().hide();

                // always hide move back button because it's not needed in main content
                if (this._btnMoveBack) {
                    this._btnMoveBack.hide();
                }

                // if container does not exist create new
                this.emit('beforeLoad', this.container);

                app.loader.display(this.container);

                app.http.get(url, $.extend({}, {
                    returnURL: this.container.attr('data-url') || cookie.get('defaultLocation') || app.config().get('route', 'defaultLocation')
                }, data), 'html', {}, true).then(function (result) {

                    if (result.xhr.getResponseHeader('Content-Type') == 'application/json') {
                        self.emit('afterLoad', self.container);

                        app.loader.hide(self.container);

                        self.reload(data);
                    } else {
                        // remove current components
                        app.component.remove(self.container);

                        self.container.hide().html(result.response).fadeIn();
                        // iterate over each controllers

                        app.component.compile(self.container);

                        // add called url
                        self.container.attr('data-url', url);
                        // add reflink
                        location.hash = url;

                        cookie.set('defaultLocation', url);

                        logger.debug('Storing location %s', url);

                        self.emit('afterLoad', self.container);

                        app.loader.hide(self.container);

                        if (callback) {
                            callback();
                        }

                        self._lastPage = self._currentPage;

                        self._currentPage = {
                            url: url,
                            data: data
                        }
                    }
                }, function (err) {
                    self.emit('afterLoad', self.container);
                    self.reload(data);
                });
                return false;
            }
        },
        replace: function (url, data, callback) {
            this._btnMoveBack = this._btnMoveBack || $(this.config.btnMoveBack);

            var self = this;

            data = data || null;

            app.http.get(url, data, 'html').then(function (html) {
                var $component = $(html);

                self.hide();

                self.container.append($component);

                app.component.compile($component).then(function () {
                    self._replacedContentList.push($component);

                    if (callback) {
                        callback(null);
                    }
                });

                $(window).scrollTop(0);

                self._btnMoveBack.fadeIn();

            }).catch(function (err) {
                callback(err);
                logger.error('Unable to replace content: %s', err.message);
            });
        },
        moveBack: function (callback) {

            if (this._replacedContentList.length > 0) {
                var content = this._replacedContentList.pop();
                app.component.remove(content);

                content.remove();

                this._btnMoveBack.hide();

                this.show();
                return;
            }

            if (!this._lastPage) {
                logger.debug('It\'s first load. Cannot move back', url);
                return;
            }

            this.display(this._lastPage.url, this._lastPage.posts, callback);
        },
        reload: function (data, callback) {

            // move back to replaced content first
            if (this._replacedContentList.length > 0) {
                this.moveBack();
                return;
            }

            if (!this._currentPage) {
                logger.debug('No ajax load. Cannot reload page');
                return;
            }

            this.container = this.container || $(this.config.container);

            this.container.attr('data-url', '');

            if (!this._currentPage.url) {
                location.reload();
            }

            if (data) {
                this._currentPage.data = app.extend({}, this._currentPage.data, data);
            }

            this.display(this._currentPage.url, this._currentPage.data, callback);
        },
        show: function () {
            var hiddenParts = this._hiddenParts.pop();

            if (hiddenParts.length === 0) {
                logger.debug('No parts was hidden previously');
                return;
            }

            var $componentContainers = app.component.findAll(this.container),
                    $childrenContainers = this.container.children();

            hiddenParts.$components.each(function () {
                app.component.show($(this));
            });

            hiddenParts.$childrens.css('display', '');

            $(window).scrollTop(hiddenParts.scrollTop); // restore to last position
        },
        hide: function () {
            var $components = app.component.findAll(this.container),
                    $childrens = this.container.children().not($components),
                    scrollTop = $(window).scrollTop();

            // exclude all previously hidden elements and components
            for (var i in this._hiddenParts) {
                $components.not(this._hiddenParts[i].$components);
                $childrens.not(this._hiddenParts[i].$childrens);
            }

            $components.each(function () {
                app.component.hide($(this));
            });

            $childrens.css('display', 'none');

            this._hiddenParts.push({
                $components: $components,
                $childrens: $childrens,
                scrollTop: scrollTop // store last position
            });
        }
    });

    // custom ajax requests
    app.http = {
        config: {
        },
        post: function (url, data, dataType, optionalParams, withXhr) {
            return this._sendRequest('POST', url, data, dataType, optionalParams, withXhr);
        },
        get: function (url, data, dataType, optionalParams, withXhr) {
            return this._sendRequest('GET', url, data, dataType, optionalParams, withXhr);
        },
        _sendRequest: function (type, url, data, dataType, optionalParams, withXhr) {
            return new Promise(function (resolve, reject) {
                optionalParams = optionalParams || {};
                withXhr = withXhr || false;
                dataType = dataType || 'json';

                if (data && type === 'POST') {
                    if (data.constructor === Array) {
                        data.push({
                            "name": app.config().get('security', 'csrf_tokenName'),
                            "value": app.security.csrf.getToken()
                        });
                    } else if (typeof (data) === 'object') {
                        data[app.config().get('security', 'csrf_tokenName')] = app.security.csrf.getToken();
                    } else {
                        throw new Error("Incorrect post data");
                    }
                }

                var params = app.extend({
                    'url': url,
                    'type': type,
                    'data': data,
                    'dataType': (dataType) ? dataType : 'json'
                }, optionalParams);

                // if file upload
                if (typeof (FormData) !== 'undefined' && params.data instanceof FormData) {
                    params.cache = false;
                    params.contentType = false;
                    params.processData = false;

                    params.data.append(app.config().get('security', 'csrf_tokenName'), app.security.csrf.getToken());
                }

                /*if(typeof FormData != 'undefined' && data instanceof FormData){
                 
                 data.append(app.config().get('security', 'csrf_tokenName'), app.security.csrf.getToken())
                 
                 params['processData'] = false;
                 params['contentType'] = false;
                 }*/

                $.ajax(params).done(function (data, status, xhr) {

                    var resolved = false;

                    try {
                        if (xhr.getResponseHeader('Content-Type') == 'application/json' && typeof data !== 'object') {
                            data = JSON.parse(data);
                        }
                    } catch (e) {
                        reject(e);
                        return;
                    }
                    if (data === null) {
                        if (withXhr)
                            resolve({response: '', xhr: xhr});
                        else
                            resolve();

                        return;
                    }

                    if (typeof (data) === 'object' && ('result' in data || 'publisher' in data || 'data' in data || 'command' in data)) {
                        var errorResp = false;

                        for (var type in data) {

                            switch (type) {
                                case 'result':
                                    if (data[type]['status'] === 'error') {
                                        errorResp = true;
                                    }

                                    app.message[data[type]['status']](data[type]['description']);
                                    break;
                                case 'command':
                                    app.command[data[type]['action']].call(null, data[type]['params']);
                                    logger.debug('Calling command %s with params %s', data[type]['action'], data[type]['params']);
                                    break;
                                case 'data':
                                    resolved = true;
                                    if (errorResp) {
                                        reject(new Error(data[type]['code']));
                                    } else {
                                        if (withXhr)
                                            resolve({response: data[type], xhr: xhr});
                                        else
                                            resolve(data[type]);
                                    }
                                    break;
                                default:
                                    '';
                            }
                        }

                        if (!resolved) {
                            if (errorResp) {
                                reject(new Error('Error message response'));
                            } else {
                                if (withXhr)
                                    resolve({response: null, xhr: xhr});
                                else
                                    resolve(null, xhr);
                            }
                        }
                    } else {
                        if (withXhr)
                            resolve({response: data, xhr: xhr});
                        else
                            resolve(data);
                    }
                }).fail(function (error) {
                    if (error.status === 401) {
                        app.message.error(app.module('System').lang().message('ACCESS_DENIED').text);
                        return reject(new Error(error));
                    }

                    app.message.error(app.module('System').lang().message('SYSTEM_ERROR').text);

                    logger.error('Ajax error: %s', error);

                    reject(new Error(error));
                });
            });
        }
    };

    /* SYSTEM PLUGINS */

    app.plugins = {
        config: {},
        configure: function (config) {
            this.config = config || {};
        }
    };

    app.component = {
        _storage: {},
        eventBus: new EventAggregator(),
        /**
         * Compile all components withing container
         * 
         * @param {object Jquery|object Document|string} container selector
         * @param {bool} removeExisting if true existing components with the same name will be removed. Othervise if component already exists an error is thrown
         * @returns {array} loadedNames component names that was loaded or reloaded or empty array
         * @rejects {Error} error
         * @throws {Error} error error from synchronou operation
         */
        compile: function (container, removeExisting) {
            var self = this;

            var $controllers = $.unique($(container).add(this.findAll(container))), // find and add all submodules to collection
                    ctrlsProcessed = 0,
                    ctrlsCount = $controllers.length,
                    loadedComponents = [];

            return new Promise(function (resolve, reject) {

                $controllers.each(function () {
                    var $controller = $(this),
                            $elements = [],
                            componentType = $controller.data('component'),
                            componentParts = [],
                            name = $controller.data('name'),
                            config = $controller.data('config') || {},
                            compiled = $controller.data('compiled');

                    if (componentType === '@remote') {
                        ++ctrlsProcessed;
                        logger.debug('Remote component "%s", ignoring...', $controller.data('url'));
                        return resolve([]);
                    }

                    if (compiled) {
                        ++ctrlsProcessed;
                        logger.debug('Component %s is already compiled', componentType);
                        return resolve([]);
                    }
                    
                    // skip undefined
                    if (!componentType) {
                        ++ctrlsProcessed;
                        return resolve([]);
                    }

                    if (self._storage[name]) {
                        if (removeExisting) {
                            self.remove(self._storage[name].$controller);
                        } else {
                            return reject(new Error('Component "' + componentType + '" with name "' + name + '" already exist.'));
                        }
                    }

                    componentParts = componentType.split('.');

                    componentParts[0] = componentParts[0].replace('app/', ''); // remove "/app" if called directly from javascript code

                    logger.debug('Loading component "%s"', componentParts[0]);
                    require(['app/' + componentParts[0]], function (Component) {
                        if (componentParts.length > 1) {
                            for (var i = 1, partsCount = componentParts.length; i < partsCount; i++) {

                                if (Component[componentParts[i]]) {
                                    Component = Component[componentParts[i]];
                                } else if (Component['prototype'][componentParts[i]]) {
                                    Component = Component['prototype'][componentParts[i]];
                                } else {
                                    return reject(new Error('Component part "' + componentParts[i] + '" not defined in "' + componentType + '"'));
                                }
                            }
                        }

                        $controller.data('compiled', {name: name, type: componentType});

                        $elements = $controller.find('*').not($controller.find('[data-component]')).not($controller.find('[data-component] *'));

                        // exclude knockout components
                        /*var $koControls = $elements.filter('[data-ko]');
                         
                         $elements = $elements.not($koControls).not('[data-ko] *');*/

                        logger.debug('Compiling component: "%s" with name: "%s" (%s) ', componentType, name, config.ID);

                        var component = new Component($controller, $elements, config.params);

                        self._storage[name] = component;

                        component.isActive = true;

                        component.eventBus = self.eventBus.register(name);

                        component.eventBus.setAliases(config.aliases);

                        // add to defined channels and groups
                        for (var index in config.groups) {
                            component.eventBus.join(config.groups[index]);
                        }

                        for (var index in config.channels) {
                            component.eventBus.subscribe(config.channels[index]);
                        }

                        // method for getting component ID
                        component.getID = function () {
                            return config.ID;
                        };

                        if (!('$controller' in component)) {
                            component.$controller = $controller;
                        }

                        if (!('$elements' in component)) {
                            component.$elements = $elements;
                        }

                        if (!('params' in component)) {
                            component.params = config.params || {};
                        }

                        if (!('data' in component)) {
                            component.data = config.data || {};
                        }

                        if (!('control' in component)) {
                            component.control = {};
                        }

                        component.$elements.attachPlugins(true).attachEvents(component, true);

                        if (typeof component['show'] === 'undefined') {
                            component.show = function () {
                                this.$controller.css('display', '');
                                this.$elements.css('display', '');
                            }
                        }

                        if (typeof component['hide'] === 'undefined') {
                            component.hide = function () {
                                this.$controller.css('display', 'none');
                                this.$elements.css('display', 'none');
                            }
                        }

                        logger.debug('Component controls: ', component.control);

                        loadedComponents.push(component);

                        ++ctrlsProcessed;

                        if (app.ENVIRONMENT !== 'development') {
                            $controller.removeAttr('data-config');
                        }

                        if (ctrlsProcessed === ctrlsCount) {
                            var loadedComponentNames = [];

                            // call init if all components was loaded
                            for (var i in loadedComponents) {
                                loadedComponentNames.push(loadedComponents[i].$controller.data('name'));

                                if (typeof loadedComponents[i].__init === 'function') {
                                    loadedComponents[i].__init.call(loadedComponents[i]);
                                }
                                
                                if (typeof loadedComponents[i].__bind === 'function') {
                                    loadedComponents[i].__bind.call(loadedComponents[i]);
                                }
                            }
                            resolve(loadedComponentNames);
                        }
                    });
                });
            });
        },
        /**
         * Remove all components within container
         * 
         * @param {object Jquery|object Document|string} container jquery selector
         * @returns {object} this
         */
        remove: function (container) {
            var self = this;

            var $controllers = $(container).add(this.findAll(container)).reverse(); // find and add all submodules to collection

            $controllers.each(function () {
                var $controller = $(this),
                        compiled = $controller.data('compiled');

                if (!compiled) {
                    logger.debug('Component is not compiled. Check if this behviour is not expected.');
                    return;
                }

                var component = self._storage[compiled.name],
                        filterElements = false;

                if (typeof component.$elements !== 'undefined') {
                    filterElements = true;
                }

                component.$elements.dettachPlugins(filterElements).dettachEvents(filterElements);

                var cleanupMethods = ['__destruct', '__unbind'];

                for (var index in cleanupMethods) {
                    if (typeof component[cleanupMethods[index]] === 'function') {
                        component[cleanupMethods[index]].call(component);
                    }
                }

                component.eventBus.unregister();

                component = null;

                delete self._storage[compiled.name];

                logger.debug('Removing compiled component "%s" with name "%s"', compiled.type, compiled.name);

                $controller.remove();
            });

            return this;
        },
        /**
         * Find all components and remove them
         * 
         * @param {object Jquery|object Document|string} container jquery selector
         * @returns {object} this
         */
        findAndRemove: function (container) {
            this.remove(this.findAll(container).reverse());

            return this;
        },
        /**
         * Return all JQuery component objects which was found within container
         * 
         * @param {object Jquery|object Document|string} container jquery selector
         * @returns {object jQuery} collection found component
         */
        findAll: function (container) {
            return $(container).find('[data-component]');
        },
        /**
         * Return first component JQuery object which was found within container
         * 
         * @param {object Jquery|object Document|string} container jquery selector
         * @returns {object jQuery} collection found component
         */
        findClosest: function (container) {
            return $(container).find('[data-component]:first');
        },
        /**
         * Display all components
         * 
         * @param {onject Jquery} $componentControllers 
         * @returns {object} this
         */
        show: function ($componentControllers) {
            var self = this;

            $componentControllers.each(function () {
                var $this = $(this),
                        name = $this.data('name');

                if (!name) {
                    logger.warn('Component does not contain "name" or is not component');
                    return;
                }

                if (!self._storage[name]) {
                    logger.warn('Component with name "%s" not found. Showing was cancelled');
                    return;
                }

                var hideCounter = self._storage[name].$controller.data('hide-counter');

                // if hide() method was called multiple times, show component only if hide() calls equal show()
                if (typeof hideCounter === 'undefined' || hideCounter === 1) {
                    self._storage[name].show();
                    self._storage[name].isActive = true;
                    logger.debug('Component was shown "%s".', name);
                } else {
                    logger.debug('Component has been hidden "%s" times.', hideCounter);
                }

                // decrement hide counter
                self._storage[name].$controller.dataIncrement('hide-counter', -1, 1);
            });

            return self;
        },
        /**
         * Hide all components
         * 
         * @param {onject Jquery} $componentControllers 
         * @returns {object} this
         */
        hide: function ($componentControllers) {
            var self = this;

            $componentControllers.each(function () {
                var $this = $(this),
                        name = $this.data('name');

                if (!name) {
                    logger.warn('Component does not contain "name" or is not component');
                    return;
                }

                if (!self._storage[name]) {
                    logger.warn('Component with name "%s" not found. Hidding was cancelled');
                    return;
                }

                self._storage[name].hide();
                self._storage[name].isActive = false;

                logger.debug('Component was hidden "%s".', name);
                // increment hide counter
                self._storage[name].$controller.dataIncrement('hide-counter', 1);
            });

            return self;
        },
        /**
         * Load all components within container
         * 
         * @param {object JQuery|object Document} object in which all components will be loaded
         * @returns {object Promise|array>} $containers JQuery collection of components that was loaded or reloaded or empty array
         * @rejects {Error} error 
         */
        load: function (container) {
            var self = this,
                    promises = [],
                    $containers = this.findAll(container),
                    loadedNames = [],
                    reloadedNames = [];

            return new Promise(function (resolve, reject) {

                if ($containers.length === 0) {
                    logger.debug('No containers found. Loading was skipped...');

                    resolve([]);
                }

                $containers.each(function () {
                    var $this = $(this);

                    promises.push(new Promise(function (resolve, reject) {
                        if ($this.data('component') !== '@remote') {

                            if ($this.data('component')) {
                                var name = $this.data('name');

                                logger.debug('Component "%s" was already loaded.', name);

                                reloadedNames.push(name);

                                if (typeof self._storage[name].reload === 'function') {
                                    logger.debug('Calling reload function on component "%s".', name);
                                    self._storage[name].reload.call(self._storage[name]);
                                }
                                resolve();
                                return;
                            }

                            resolve();

                            logger.warn('Component "%s" is not remote. Skipping...');
                            return;
                        }

                        app.loader.display($this);

                        app.http.get($this.data('url'), null, 'html').then(function (response) {
                            var $response = $(response);

                            $this.replaceWith($response);

                            self.compile($response).then(function (names) {

                                loadedNames = names;

                                app.loader.hide($this);
                                resolve();
                            });

                        }).catch(function (err) {
                            reject(err);
                            logger.error('Unable to download content: %s', err.message);
                        });
                    }));
                });

                Promise.all(promises).then(function () {
                    resolve({loadedNames: loadedNames, reloadedNames: reloadedNames});
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    };

    // keep connection with server during inactivity (5 minutes)
    setInterval(function () {
        var cacheName = 'system.update.ignored';
        app.http.get('/system/ping').then(function (version) {
            if (version !== app.VERSION) {
                if (!cookie.get(cacheName)) {
                    if (confirm('Bola zaznamenaná novšia verzia aplikácie. Prajete si ju načítať? (neuložené dáta budú stratené)')) {
                        cookie.remove(cacheName);
                        window.location.reload(true);
                    } else {
                        cookie.set(cacheName, 'ignored', {expires: 1}); // repeat every 24 hours
                    }
                }
            }
        });
    }, 300000);

    var _cleanData = $.cleanData;
    $.cleanData = function (elems) {
        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
            try {
                $(elem).triggerHandler("remove");
                // http://bugs.jquery.com/ticket/8235
            } catch (e) {
            }
        }
        _cleanData(elems);
    };

    $.fn.attachPlugins = function (filterElements) {
        var config = app.plugins.config,
                action = (filterElements) ? 'filter' : 'find';

        for (var selector in config) {
            var classes = this[action](selector).filter(function (index) {
                var $this = $(this),
                        activatedSelectors = $this.data('plugin-activated-selectors');

                if ($this.data('plugin-ignore')) {
                    return false;
                }

                if (!activatedSelectors) {
                    $this.attr('data-plugin-activated-selectors', [selector].join('|'));
                    return true;
                } else {
                    activatedSelectors = activatedSelectors.split('|');

                    if (activatedSelectors.indexOf(selector) === -1) {
                        activatedSelectors.push(selector);
                        $this.attr('data-plugin-activated-selectors', activatedSelectors.join('|'));

                        return true;
                    } else {
                        return false;
                    }
                }
            });
            if (!classes.length) {
                continue;
            }

            if (typeof config[selector][0] === 'function') {
                config[selector][0]($(classes));
            }
        }
        ;
        return $(this);
    };

    $.fn.dettachPlugins = function (filterElements) {
        var config = app.plugins.config,
                action = (filterElements) ? 'filter' : 'find';

        for (var selector in config) {
            var classes = this[action](selector).filter(function (index) {
                var $this = $(this),
                        activatedSelectors = $this.data('plugin-activated-selectors');

                if ($this.data('plugin-ignore')) {
                    return false;
                }

                if (!activatedSelectors) {
                    return false;
                } else {
                    activatedSelectors = activatedSelectors.split('|');

                    if (activatedSelectors.indexOf(selector) === -1) {
                        activatedSelectors.push(selector);
                        $this.attr('data-plugin-activated-selectors', activatedSelectors.join('|'));

                        return false;
                    } else {
                        return true;
                    }
                }
            });

            if (!classes.length) {
                continue;
            }

            if (typeof config[selector][1] === 'function') {
                config[selector][1]($(classes));
            }

            $(classes).find('*').off();
        }
        return $(this);
    };

    /*
     Apply event defined in data-action attribute format 
     
     data-action{'event': 'functionName or publisher'}
     data-param{'event': 'data'}
     */
    $.fn.attachEvents = function (toObj, filterElements) {
        var action = (filterElements) ? 'filter' : 'find';

        function splitCommand(command) {
            command = command.replace(/\s/g, '');

            var commandParts = command.split('|'),
                    result = {};

            for (var i in commandParts) {
                var parts = commandParts[i].split(':');

                result[parts[0]] = parts[1];
            }

            return result;
        }

        $(this)[action]('[data-action]').each(function () {
            var $this = $(this),
                    actions = splitCommand($this.data('action')), /* e.g. data-action="click:methodName|hover:anotherMethodName" */
                    preventDefault = ($this.data('preventdefault') === false) ? false : true,
                    eventsCount = 0;

            for (var event in actions) {
                var selector = $this.data('selector'); /* e.g. data-selector="click:li|hover|.active" */

                if (selector) {
                    var selectorParams = splitCommand(selector),
                            selector = (selectorParams[event]) ? selectorParams[event] : null;
                }

                $this.off(event); // remove previously attached event

                // apply event
                $this.on(event, selector, function (e) {

                    var param = {},
                            objParam = $(this).data('param');
                    if (objParam) {
                        param = objParam[e.type];
                    } else {
                        param = $(this).data(e.type) || null;
                    }
                    if (preventDefault) {
                        e.preventDefault();
                    }
                    // if defined object
                    if (typeof (toObj) === 'object') {
                        var method,
                                subMethod = false;

                        // if dotted notation convert to obj
                        if (actions[e.type].indexOf('.') !== -1) {
                            var methods = actions[e.type].split('.');

                            method = toObj[methods[0]];

                            if (typeof method === 'undefined') {
                                logger.debug('Action %s is not defined in object %s', actions[e.type], toObj.toString());
                                return;
                            }

                            for (var i = 1, length = methods.length; i < length; i++) {
                                method = method[methods[i]];
                            }
                            subMethod = true;
                        } else {
                            method = toObj[actions[e.type]];
                        }
                        if (typeof (method) !== 'function') {
                            logger.debug('Attached component method "%s" is not a function', method);
                            return;
                        }

                        var args = [param, e]; /*if( ! subMethod){ args.unshift($(this)); }*/

                        args.unshift($(this));

                        method.apply(toObj, args);
                    } else {
                        logger.warn('"%s" has not defined object', event);
                    }
                });
                if (event === 'onLoad') {
                    $this.trigger(event);
                }

                ++eventsCount;
            }

            logger.debug('Attached %s events', eventsCount);
        });
        return $(this);
    };

    $.fn.dettachEvents = function (filterElements) {
        var action = (filterElements) ? 'filter' : 'find';

        $(this)[action]('[data-action]').off();

        return $(this);
    };

    $.fn.modifyEvent = function (action, param) { /*$(this).find('[data-action]').each(function(){*/
        var $this = $(this);
        if (typeof (action) === 'object') {
            $this.data('action', $.extend($this.data('action'), action));
        }
        if (typeof (param) === 'object') {
            $this.data(action, $.extend($this.data(action), param));
        } /*});*/
    };

    $.fn.serializeAll = function () {
        var values = $(this).serializeArray();
        $(this).find('input[type=checkbox]').map(function () {
            var $this = $(this),
                    unselectedVal = $this.data('unchecked-value') || 0;

            if ($this.is(':checked')) {
                values.push({
                    "name": this.name,
                    "value": this.value
                });
            } else {
                if (typeof unselectedVal !== 'undefined') {
                    values.push({
                        "name": this.name,
                        "value": unselectedVal
                    });
                }
            }
        });

        $(this).find('select[multiple]').map(function () {
            var $this = $(this);

            // if no value was selected in multiselect then send empty
            if ($this.val() === null) {
                values.push({
                    "name": this.name,
                    "value": ""
                });
            }
        });

        return values;
    };

    /**
     * Call $.serializeAll and add csfr params to data
     * 
     * @returns {object} data serialized data from method $.serializeAll
     */
    $.fn.serializeArraySecure = function () {
        var data = $(this).serializeAll();
        data.push({
            "name": app.security.csrf.getName(),
            "value": app.security.csrf.getToken()
        });
        return data;
    };

    /**
     * Check if given element is active or not by special class.
     * 
     * @param {type} setActive set "true" or "false" if given object will be active or inactive after calling this method.
     * @returns {Boolean} True if Active and False if Inactive
     */
    $.fn.isActive = function (setActive) {
        var $this = $(this),
                className = '__is-active';

        if (typeof setActive !== 'undefined' && setActive === false) {
            $this.removeClass(className);
        }

        if ($this.hasClass(className)) {
            return true;
        }

        if (typeof setActive === 'undefined' || setActive === true) {
            $this.addClass(className);
        }

        return false;
    }

    /**
     * Check if form is valid by jquery validation plugin
     * 
     * @returns {object JQuery} $
     */
    $.fn.isValid = function () {
        var valid = true;

        $(this).each(function () {
            if (!$(this).valid()) {
                valid = false;
                app.message.error('Formulár nie je správne vyplnený!!');
                return false;
            }
        });
        return valid;
    };

    /**
     * Apply jquery validation plugin to given form
     * 
     * @param {string} config Config params are based on jquery validation plugin (http://jqueryvalidation.org/)
     * @returns {object JQuery} $
     */
    $.fn.applyValidator = function (config) {
        config = config || {};

        var $this = $(this),
                defaults = {
                    'errorClass': 'inputError',
                    'errorPlacement': function (error, element) {
                        logger.debug('Form error: %s', $(error).text());

                        var $element = $(element);

                        $element.closest('.form-group').addClass('has-error');

                        if ($element.parent().hasClass('input-group')) {
                            $element.parent().next('.label-danger').remove();
                            $element.parent().after('<span class="label label-danger">' + $(error).text() + '</span>');
                        } else {
                            $element.next('.label-danger').remove();
                            $element.after('<span class="label label-danger">' + $(error).text() + '</span>');
                        }

                        return;
                    },
                    success: function (label, element) {
                        var $element = $(element);

                        $element.closest('.form-group').removeClass('has-error');

                        if ($element.parent().hasClass('input-group')) {
                            $element.parent().next('.label-danger').remove();
                        } else {
                            $element.next('.label-danger').remove();
                        }
                    },
                    'ignore': ''
                };

        $this.each(function () {
            $(this).removeData('validator'); // remove previous validator if set

            $(this).validate($.extend(defaults, config));
        });
        return $this;
    };

    /**
     * Clear all values in given form
     * 
     * @returns {object JQuery} $
     */
    $.fn.clear = function () {
        // iterate each matching form
        return $(this).each(function () {
            // iterate the elements within the form
            $(':input', this).not('.no-reset').each(function () {
                var type = this.type,
                        tag = this.tagName.toLowerCase();
                if (type === 'text' || type === 'password' || tag === 'textarea' || type === 'hidden')
                    this.value = '';
                else if (type === 'checkbox' || type === 'radio')
                    this.checked = false;
                else if (tag === 'select')
                    this.selectedIndex = '';
            });
        });
    };

    /**
     * Reset all inputs in given form
     * 
     * @returns {object JQuery} $
     */
    $.fn.reset = function () {
        var $this = $(this);

        $(this)[0].reset();

        $(this).find(':input')
                .not(':button, :submit, :reset, :hidden')
                .each(function () {
                    $(this).trigger('reset');
                });
    };

    /**
     * Restore data in given form
     * 
     * @param {object} data {key : value} "key" is the name of input. "value" which will be asssigned to given input
     * @returns {object JQuery} $
     */
    $.fn.formRestore = function (data) {
        var els = $(this).find(':input').get();

        $.each(els, function () {
            if (this.name && typeof data[this.name] !== 'undefined') {
                if (this.type === 'checkbox' || this.type === 'radio') {
                    $(this).attr("checked", (data[this.name] === $(this).val()));
                } else {
                    $(this).val(data[this.name]);
                }
            }
        });
    };

    /**
     * Load content into div from server address defined in data-content="$url" or defined sa param
     * 
     * @param {string} url
     * @param {bool} compile default true which means that app will try to find and compile components
     * @param {bool} displayLoader default true which means that loader will be inserted into div during load
     * @returns {object Promise<object>} compiled components array
     * @rejects {Error} error
     */
    $.fn.loadContent = function (url, data, compile, displayLoader) {
        var $this = $(this);
        
        compile = compile || true;
        displayLoader = displayLoader || true;
        url = $this.data('content') || url;
        data = data || null;

        if (!url) {
            return Promise.reject(new Error('Unable to find url in content.'));
        }

        if (displayLoader) {
            app.loader.display($this);
        }
        
        app.component.remove($this);

        return app.http.get(url, data, 'html').then(function (response) {
            if (displayLoader) {
                app.loader.hide($this);
            }

            $this.html(response);

            if (!compile) {
                return [];
            }

            return $this.compile(true);
        }).catch(function (err) {
            logger.error('Unable to download content: %s', err.message);
            reject(err);
        });
    };

    /**
     * Remove element classes with wildcard matching.  
     * 
     * @param {string} prefix - class wildacr e.g. class-*
     * @returns {$.fn}
     */
    $.fn.removeClassPrefix = function (prefix) {
        this.each(function (i, el) {
            var classes = el.className.split(" ").filter(function (c) {
                return c.lastIndexOf(prefix, 0) !== 0;
            });
            el.className = $.trim(classes.join(" "));
        });

        return this;
    };

    /*
     * @param {object} options
     * @param {function} options.success call a function if request was sucessfull
     * @param {function} options.error call a function if request was failed
     * @returns {undefined}
     */
    $.fn.editable = function (options) {
        var $this = $(this);

        if ($this.data('editable')) {
            return;
        }

        $this.data('editable', true);


        var options = options || {},
                event = $this.data('editable-event') || ($this.is(':input')) ? 'change' : 'click', // set default event
                url = $this.data('editable-url'),
                data = $this.data('editable-data') || {};

        $this.on(event, function () {

            // if input add value
            if ($this.is(':input')) {
                data[$this.attr('name')] = $this.val();
            }

            app.http.post(url, data, 'json').then(function (response) {
                if (typeof options.success === 'function') {
                    options.success(response);
                }
            }).catch(function (err) {
                if (typeof options.error === 'function') {
                    options.error(err);
                }

                // restore back to original value
                $this.val(data[$this.attr('name')]);
            });
        });
    }
    /**
     * Increment or decrement value in data attribute. If not defined, value is set to default
     * 
     * @param {string} prop property name
     * @param {integer} val increment on positive value, decrement on negative
     * @param {integer} defaultVal default value if property does no exists. If not defined "1" is used (optional)
     * @returns {object JQuery}
     */
    $.fn.dataIncrement = function (prop, val, defaultVal) {
        var defaultVal = defaultVal || 0;

        return this.each(function () {
            var data = $(this).data();
            if (!(prop in data)) {
                data[prop] = defaultVal;
            }
            data[prop] += val;
        });
    }

    /**
     * Reverse items in JQuery collection
     */
    $.fn.reverse = [].reverse;

    /**
     * Replace class
     * 
     * @param {string} classToRemove
     * @param {string} replaceWithClass
     * @returns JQuery
     */
    $.fn.replaceClass = function (classToRemove, replaceWithClass) {
        return $(this).removeClass(classToRemove).addClass(replaceWithClass);
    }

    /**
     * Find and compile components in selector
     * 
     * @param {bool} removeExisting
     * @returns {Promise}
     */
    $.fn.compile = function (removeExisting) {
        return app.component.compile($(this), removeExisting || true);
    }

    return app;
});